<template>
  <div class="footerBox">
    <div v-if="$store.state.showFooter" class="footer-container">
      <!-- 第一排：Logo -->
      <div class="footer-logo-row">
        <div class="logo">
          <img src="@/assets/logo.png" alt="" />
          <span>融鑫通贸易平台</span>
        </div>
      </div>
      <!-- 第二排：导航栏和联系我们 -->
      <div class="footer-content-row">
        <!-- 左侧导航 -->
        <div class="nav-links">
          <div @click="toPage('Home')">首页</div>
          <div @click="toPage('Procurement')">招采中心</div>
          <div @click="toPage('WantBuy')">求购中心</div>
          <div @click="toPage('Info')">信息中心</div>
          <div @click="toPage('Finance')">金融中心</div>
          <div @click="toPage('About')">关于融鑫通</div>
        </div>
        <!-- 右侧：联系信息和二维码 -->
        <div class="footer-right">
          <div class="contact-info">
            <div class="contact-title">联系我们</div>
            <div class="contact-row">
              <span>电话：19915874927</span>
              <span>邮箱：17883588727@139.com</span>
            </div>
            <div class="contact-row">
              <span>公司地址：成龙大道二段888号51栋5层</span>
            </div>
          </div>
          <!-- <div class="qr-code">
            <div class="qr-placeholder"></div>
          </div> -->
        </div>
      </div>
      <!-- 底部版权区 -->
      <div class="footer-bottom">
        <p>
          中北服科技有限公司版权所有
          <span class="beian-link" @click="openBeian">
            蜀ICP备2026012903号
          </span>
        </p>
        <!-- <p>
          网站内容未经许可严禁复制，中国xx实验室（工业和信息化部电子第五研究所）
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    toPage(name) {
      if (name === "Home") {
        this.$router.push("/");
      } else {
        this.$router.push({ name });
      }
    },
    openBeian() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";

.footerBox {
  min-width: @commentWidth;
  background: #1a2b4a;

  .footer-container {
    width: @defaultWidth;
    margin: 0 auto;
    padding: 40px 0 20px;
  }

  // 第一排：Logo
  .footer-logo-row {
    margin-bottom: 20px;

    .logo {
      display: flex;
      align-items: center;

      img {
        width: 38px;
        height: 36px;
        margin-right: 10px;
        border-radius: 7px;
      }

      span {
        font-size: 16px;
        color: #ffffff;
        font-weight: 500;
      }
    }
  }

  // 第二排：导航和联系我们
  .footer-content-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-bottom: 1px solid #515f7a;
    border-top: 1px solid #515f7a;
    padding: 20px 0;

    .nav-links {
      display: flex;
      gap: 30px;

      div {
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  // 右侧区域
  .footer-right {
    display: flex;
    align-items: center;
    gap: 40px;

    .contact-info {
      .contact-title {
        font-size: 20px;
        color: #ffffff;
        font-weight: 500;
        margin-bottom: 15px;
      }

      .contact-row {
        display: flex;
        gap: 40px;
        margin-bottom: 10px;

        span {
          font-size: 14px;
          color: #747f95;
          white-space: nowrap;
        }
      }
    }

    // 二维码占位区域
    .qr-code {
      .qr-placeholder {
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px dashed rgba(255, 255, 255, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  // 分隔线
  .footer-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.15);
    margin-bottom: 15px;
  }

  // 底部版权区
  .footer-bottom {
    text-align: center;

    p {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.6;
      margin: 0;

      &:first-child {
        margin-bottom: 5px;
      }

      .beian-link {
        margin-left: 6px;
        cursor: pointer;

        &:hover {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
